/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from 'react'
import { apiPost } from 'tennders-stracture/libs/api'
import useTranslation from 'next-translate/useTranslation'
import SearchableAsyncSelect from 'tennders-common/form/components/new-inputs/SearchableAsyncSelect'

const requestTransactions = (companyId, companyType, page = 1, search = '') => {
  const attributes = '{id, referenceNumber, createdAt {d}, matchedTruck{totalPrice, bookRate, id, paymentTerm{days}, cmrDocument{name, fullUri}, orderDoc{title, id}}, approvedSalesInvoice{id, uniqueFileName,documentUrl}, salesInvoice{id}, approvedSalesInvoices, hasSalesInvoice, costInvoices{id}, pendingAmounts{id,amount}}'
  return apiPost(
    '/financial-transactions/ofCompany',
    {
      attributes,
      company: companyId,
      companyType,
      page,
      query: search
    }
  )
}

const TransactionSelectInput = (props) => {
  const {
    error,
    selectedOptionLabel,
    onTransactionChange,
    companyId = null,
    showError,
    withAll,
    companyType,
    disabled
  } = props
  const { t } = useTranslation()
  const [transactions, setTransactions] = useState([])
  const loadTransactions = useCallback(async (page, search) => {
    if (companyId) {
      const response = await requestTransactions(companyId, companyType, page, search)
      if (response) {
        const transactionsFiltered = response?.items?.map(transaction => ({
          label: transaction?.referenceNumber,
          ...transaction
        }))
        if (withAll) {
          transactionsFiltered.unshift({ id: 'all', label: 'All' })
        }

        if (transactionsFiltered) {
          setTransactions([...transactionsFiltered])
        }
      }
      return [response.items, response?.meta?.pagination?.totalPage > page]
    }

    return [[], false]
  }, [companyId])

  const setTransaction = useCallback((transaction) => {
    if (transaction?.id === 'all') {
      onTransactionChange(null)
    } else {
      if (companyType !== 'shipper' && !transaction?.matchedTruck?.orderDoc?.id) {
        return window.alert(t('errors:no-order-doc'))
      }
      onTransactionChange(transaction)
    }
  }, [transactions])

  useEffect(() => {
    if (companyId) {
      loadTransactions(1, '')
    }
  }, [companyId])

  return (
    <SearchableAsyncSelect onSet={setTransaction} labelKey="referenceNumber" disabled={disabled} fetchCallback={loadTransactions}>
      <div className={`smaller form-input form-select w-100${disabled ? ' disabled' : ''}`}>
        <div className="d-flex align-center h-100 mr-12">
          {selectedOptionLabel || t('common:select')}
        </div>
      </div>
    </SearchableAsyncSelect>
  )
}

export default TransactionSelectInput
